import { ITypedReduxAction } from '../../types/redux/actionType';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export const SET_AMOUNT_ERROR = 'PAYMENT_WIDGET :: LAYOUT :: SET_WIDGET_ERROR';

export type TSetAmountErrorAction = ITypedReduxAction<typeof SET_AMOUNT_ERROR, string | null>;

export const setAmountError = actionGenerator<typeof SET_AMOUNT_ERROR, string | null>(SET_AMOUNT_ERROR);
